import { render } from "./dashboard-widgets.vue?vue&type=template&id=30b87e02"
import script from "./dashboard-widgets.vue?vue&type=script&lang=js"
export * from "./dashboard-widgets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__